/**
 * A nudge from Kaoto's own menu to the workspace drawer that holds the console screens.
 *
 * The screens are not routes — they render in the "Workspace library" modal from local state —
 * so the menu cannot navigate to one by setting a hash. Kaoto's router owns the hash and answers
 * an unknown one with its error page.
 */
const listeners = new Set<() => void>();

export const onOpenPeople = (listener: () => void): (() => void) => {
  listeners.add(listener);

  return () => listeners.delete(listener);
};

export const openPeople = (): void => {
  for (const listener of listeners) listener();
};
